export type AppsFlyerClient = Readonly<{
  initSdk: (
    settings: AppsFlyerSettings,
    success?: (result: string) => void,
    failure?: (error: string) => void,
  ) => void;

  onInstallConversionData: (callback: (data: Record<string, unknown>) => void) => () => void;

  setCustomerUserId: (userId: string | null, callback?: (result: string) => void) => void;

  logEvent: (
    eventName: string,
    eventValues?: Record<string, unknown>,
    success?: (result: string) => void,
    failure?: (error: string) => void,
  ) => void;
}>;

export type AppsFlyerResult = Readonly<{
  initializeAppsFlyer: () => Promise<void>;
  logPurchaseEvent: (payload: AppsFlyerPurchasePayload) => void;
  setCustomerUserId: (userId: string | null) => void;
}>;

type AppsFlyerPurchasePayload = Readonly<{
  orderId: string;
  orderValue: number;
  orderType: string;
  bagCount: number;
  productIds: string;
}>;

type AppsFlyerSettings = Readonly<{
  devKey: string;
  isDebug: boolean;
  appId: string;
  onInstallConversionDataListener?: boolean;
  onDeepLinkListener?: boolean;
  timeToWaitForATTUserAuthorization: number;
}>;
